const CLEVERREACH_SITE_KEY = '6Lfhcd0SAAAAAOBEHmAVEHJeRnrH8T7wPvvNzEPD'
const SITE_KEY = '6LfT_9sZAAAAALAYnLA9X-Zgx_op8YfTgOnC4yw8'

export { CLEVERREACH_SITE_KEY, SITE_KEY }
